import { Component, EventEmitter, Output, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewEncapsulation, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { Subscription } from 'rxjs';
import * as _ from 'lodash-es';
import { PartnerAllocService } from './partner-alloc.service';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import { safeEvalFormula } from '../../../shared/_utils/safe-eval-formula';
import {
  extractObject,
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
} from '../../../shared/workspace-element-context';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-partner-alloc',
    templateUrl: './partner-alloc.component.html',
    styleUrls: ['./partner-alloc.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PartnerAllocComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);


  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  private readonly subs = new Subscription();

  baseURLs: any = {};
  filterParams: any = {};
  globalParams: any = {};
  USER_SETTINGS: any = {};
  SERVER_CONFIG: any = {};
  GENERAL_CONFIG: any = {};
  rowData: any = {};

  private isInitialized = false;
  private isLoading = false;

  // Standard component properties (V9 MANDATORY)
  minimise = false;
  isSaveClicked = false;
  crudLoading = false;
  showFormLoader = true;

  // Title
  modalTitle = '';
  allocationHeading = '';

  // User
  logged_in_user = '';

  // Tab state
  activeTab = 'TI';
  tabs = [
    { id: 'TI', name: 'TI / Other Info' },
    { id: 'FTC', name: 'FTC' },
    { id: 'FSI_GI', name: 'FTC - Gross Income Detail' },
    { id: 'BEAT_GILTI_FDII', name: 'BEAT/GILTI/FDII' }
  ];

  // Row data fields
  TAX_YEAR = '';
  scenario = '';
  jcd_key = '';
  COMBINATION_KEY = '';
  PTR_COMBINATION_KEY = '';
  PSHIP_PTR_POSTING_KEY = '';
  PSHIP_INTERNAL_EXTERNAL_INDICATOR = '';

  // K1 tab data
  allFormData: any[] = [];
  partHeaderIIFormData: any[] = [];
  k1caplibFormData: any[] = [];
  partHeaderIIIFormData: any[] = [];
  tiFormData: any[] = [];
  creditFormData: any[] = [];
  amtaceFormData: any[] = [];
  otherFormData: any[] = [];
  taxcapitalFormData: any[] = [];

  // K1 section toggles
  showK1Caplib = false;
  showTI = true;
  showCredits = false;
  showAMTACE = false;
  showOTHER = false;
  showTAXCAPITAL = false;

  // K1 dropdowns/formulas
  issueList: any[] = [];
  selectedIssue = '';
  allDropdownList: any[] = [];
  allFormFormulaList: any[] = [];

  // FSI tab data
  fsiFormData: any[] = [];
  partHeaderIIIFSIFormData: any[] = [];
  partHeaderDynamic: any[] = [];
  partHeaderElement: any = {};
  countryKeys: string[] = [];
  countryDetails: string[] = [];
  colspan = 2;
  showFSI = true;

  // FSI-GI (sourcing) data
  countryList: any[] = [];
  myCountryList: any[] = [];
  mySelectedCountry: any = {};
  allBasketData: any[] = [];
  selectedBasketData: any[] = [];
  fsiGIBasketData: any[] = [];
  fsiGIBasketDataByCountry: any[] = [];
  countriesToRemove: any[] = [];
  countryPresent = false;
  countryKeyList = '';
  chart_key: any[] = [];

  // FSI basket totals
  general_amt_fsi = 0;
  branch_amt_fsi = 0;
  passive_amt_fsi = 0;
  treaty_amt_fsi = 0;
  sec901j_amt_fsi = 0;
  general_amt_total = 0;
  branch_amt_total = 0;
  passive_amt_total = 0;
  treaty_amt_total = 0;
  sec901j_amt_total = 0;
  general_amt_var = 0;
  branch_amt_var = 0;
  passive_amt_var = 0;
  treaty_amt_var = 0;
  sec901j_amt_var = 0;

  // BEAT/GILTI/FDII data
  beatGiltiFdiiData: any[] = [];
  beatData: any[] = [];
  giltiData: any[] = [];
  fdiiData: any[] = [];
  s864c8Data: any[] = [];

  // Alpha array
  alphaArray = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z','aa','ab','ac','ad','ae','af','ag','ah','ai','aj','ak','al','am','an','ao','ap','aq','ar','as','at','au','av','aw','ax','ay','az'];

  // Tab disable flags (based on TAX_YEAR)
  get ftcTabDisabled(): boolean {
    return Number(this.TAX_YEAR) > 2020;
  }

  get ftcGITabDisabled(): boolean {
    return Number(this.TAX_YEAR) > 2020 || !this.countryPresent;
  }

  get beatGiltiTabDisabled(): boolean {
    return Number(this.TAX_YEAR) !== 2020;
  }

  constructor(
    private service: PartnerAllocService,
    private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService,
    private cdr: ChangeDetectorRef,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.init();
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.applyWorkspaceContext();
        this.init();
      })
    );
    this.subs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
        this.init();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const activeData = activeScreen?.data || {};

    this.GENERAL_CONFIG = generalConfigFromGlobal(this.gtwGlobal);
    this.globalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace);
    this.USER_SETTINGS = this.gtwApp.USER_SETTINGS || {};
    this.SERVER_CONFIG = this.gtwApp.SERVER_CONFIG || {};
    this.filterParams = normalizeFilterParams(activeScreen);
    const rawRow = rowPayloadFromActiveScreen(activeScreen);
    this.rowData = Array.isArray(rawRow) ? extractObject(rawRow[0]) : extractObject(rawRow);

    this.baseURLs = this.GENERAL_CONFIG;
    this.cdr.markForCheck();
  }

  private init() {
    if (this.isInitialized || this.isLoading) return;
    if (!this.GENERAL_CONFIG || !this.rowData || Object.keys(this.rowData).length === 0) return;
    if (!this.filterParams || Object.keys(this.filterParams).length === 0) return;
    this.isInitialized = true;
    try {
      this.logged_in_user = this.USER_SETTINGS?.user?.sso_id || '';
      this.setupRowDataFields();
      this.setupTitle();
      this.loadK1Data();
      this.loadFSIData();
      this.loadBeatGiltiFdiiData();
      this.loadIssueDropdown();
      this.loadAllDropdowns();
      this.loadFormFormulas();
      this.loadCountryList();
    } catch (e) {
      console.error('Error in init:', e);
      this.showFormLoader = false;
      this.cdr.detectChanges();
    }
  }

  private setupRowDataFields() {
    this.TAX_YEAR = this.filterParams.tax_year || this.rowData.TAX_YEAR || '';
    this.scenario = this.filterParams.scenario || this.rowData.SCENARIO || '';
    this.jcd_key = this.globalParams?.jcd_key || this.filterParams.jcd_key || '';
    this.COMBINATION_KEY = this.rowData.COMBINATION_KEY || '';
    this.PTR_COMBINATION_KEY = this.rowData.PTR_COMBINATION_KEY || '';
    this.PSHIP_PTR_POSTING_KEY = this.rowData.PSHIP_PTR_POSTING_KEY || '';
    this.PSHIP_INTERNAL_EXTERNAL_INDICATOR = this.rowData.PSHIP_INTERNAL_EXTERNAL_INDICATOR || '';

    if (this.PSHIP_INTERNAL_EXTERNAL_INDICATOR === 'INTERNAL') {
      this.allocationHeading = 'Partner Allocation - Schedule K';
    } else if (this.PSHIP_INTERNAL_EXTERNAL_INDICATOR === 'EXTERNAL') {
      this.allocationHeading = 'Partner Allocation - External K1';
    }

    // Update tab disabled state based on TAX_YEAR
    this.tabs = [
      { id: 'TI', name: 'TI / Other Info' },
      { id: 'FTC', name: 'FTC' },
      { id: 'FSI_GI', name: 'FTC - Gross Income Detail' },
      { id: 'BEAT_GILTI_FDII', name: 'BEAT/GILTI/FDII' }
    ];
  }

  private setupTitle() {
    this.modalTitle = 'Partnership Details: ' + (this.rowData.PSHIP_LEID || '') + ' / ' +
      (this.rowData.PSHIP_REPORTING_PERIOD || '') + ' - Partner Details: ' +
      (this.rowData.POSTING_PARTNER_LEID || '') + ' / ' + (this.rowData.POSTING_PARTNER_REPORTING_PERIOD || '');
  }

  // ─── K1 TAB DATA LOADING ─────────────────────────────────────────────

  private loadK1Data() {
    this.showFormLoader = true;
    this.isLoading = true;

    this.service.loadK1FormDetails(
      this.GENERAL_CONFIG.base_url, this.TAX_YEAR, this.scenario, this.rowData, this.logged_in_user
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.processK1FormData(response.jsonObject || []);
        this.loadIssueDetails();
        this.showFormLoader = false;
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      (error: any) => {
        console.error('Error loading K1 form details:', error);
        this.showFormLoader = false;
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
  }

  private processK1FormData(data: any[]) {
    this.allFormData = data;
    this.partHeaderIIFormData = _.filter(data, { ATTRIB_NAME: 'EXTK1_K1_II_PART_HEADER' });
    this.k1caplibFormData = _.filter(data, { SECTION_NAME: 'K1CAPLIB' });
    this.partHeaderIIIFormData = _.filter(data, { ATTRIB_NAME: 'EXTK1_K1_III_PART_HEADER' });
    this.tiFormData = _.filter(data, { SECTION_NAME: 'TI' });
    this.creditFormData = _.filter(data, { SECTION_NAME: 'CREDIT' });
    this.amtaceFormData = _.filter(data, { SECTION_NAME: 'AMTACE' });

    const otherRaw = _.filter(data, { SECTION_NAME: 'OTHER' });
    this.otherFormData = otherRaw.map((obj: any) => {
      if (this.isJson(obj.ATTRIB_VALUE) && obj.SUB_FORM != null) {
        obj.ATTRIB_VALUE = safeJsonInput<any>(obj.ATTRIB_VALUE, null, 'partner-alloc.parse1');
      }
      return obj;
    });

    this.taxcapitalFormData = _.filter(data, { SECTION_NAME: 'TAXCAPITAL' });
  }

  private loadIssueDetails() {
    this.service.loadIssueDetails(
      this.GENERAL_CONFIG.base_url, this.TAX_YEAR, this.scenario, this.jcd_key,
      this.COMBINATION_KEY, this.PTR_COMBINATION_KEY
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        if (response.jsonObject?.length > 0) {
          this.selectedIssue = response.jsonObject[0].ISSUE_ID_SHORT_DESC || '';
        }
        this.cdr.detectChanges();
      },
      () => {}
    );
  }

  private loadIssueDropdown() {
    this.service.loadIssueDropdown(
      this.GENERAL_CONFIG.base_url, this.TAX_YEAR, this.scenario, this.jcd_key
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.issueList = response.jsonObject || [];
        this.cdr.detectChanges();
      },
      () => {}
    );
  }

  private loadAllDropdowns() {
    this.service.loadAllDropdowns(this.GENERAL_CONFIG.base_url, this.TAX_YEAR).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.allDropdownList = response.jsonObject || [];
        this.cdr.detectChanges();
      },
      () => {}
    );
  }

  private loadFormFormulas() {
    this.service.loadFormFormulaDetails(
      this.GENERAL_CONFIG.base_url, this.TAX_YEAR, this.scenario
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.allFormFormulaList = response.jsonObject || [];
        this.cdr.detectChanges();
      },
      () => {}
    );
  }

  private loadCountryList() {
    this.service.loadCountryList(
      this.GENERAL_CONFIG.base_url, this.TAX_YEAR, this.logged_in_user
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.countryList = response.jsonObject || [];
        this.cdr.detectChanges();
      },
      () => {}
    );
  }

  // ─── FSI TAB DATA LOADING ─────────────────────────────────────────────

  private loadFSIData() {
    this.service.loadFSIFormDetails(
      this.GENERAL_CONFIG.base_url, this.TAX_YEAR, this.scenario, this.rowData, this.logged_in_user
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.processFSIFormData(response.jsonObject || []);
        this.cdr.detectChanges();
      },
      (error: any) => {
        console.error('Error loading FSI form details:', error);
        this.cdr.detectChanges();
      }
    );
  }

  private processFSIFormData(data: any[]) {
    this.fsiFormData = _.filter(data, { SECTION_NAME: 'FSI' });
    this.partHeaderIIIFSIFormData = _.filter(data, { ATTRIB_NAME: 'EXTK1_K1_III_PART_HEADER' });

    if (this.partHeaderIIIFSIFormData.length === 0) return;

    this.partHeaderElement = this.partHeaderIIIFSIFormData[0];
    const partHeaderElementAttribValue = this.partHeaderElement.ATTRIB_VALUE;

    this.countryKeys = this.partHeaderElement.COUNTRY_KEY ? this.partHeaderElement.COUNTRY_KEY.split('~~') : [];
    this.countryDetails = partHeaderElementAttribValue ? partHeaderElementAttribValue.split('~~') : [];

    const countryAttribName = this.partHeaderElement.ATTRIB_NAME;
    this.partHeaderElement = { ...this.partHeaderElement };
    this.partHeaderElement.ATTRIB_NAME = countryAttribName + '_0';
    this.partHeaderElement.ATTRIB_VALUE = this.countryDetails[0];

    this.partHeaderDynamic = [];
    for (let i = 1; i < this.countryDetails.length; i++) {
      this.colspan = this.colspan + 1;
      const clonedHeader = { ...this.partHeaderElement };
      clonedHeader.ATTRIB_NAME = countryAttribName + '_' + i;
      clonedHeader.ATTRIB_VALUE = this.countryDetails[i];
      clonedHeader.ATTRIB_DESCRIPTION = this.countryDetails[i];
      this.partHeaderDynamic.push(clonedHeader);
    }

    // Build DYNAMIC_COUNTRY for each FSI row
    for (let j = 0; j < this.fsiFormData.length; j++) {
      if (this.fsiFormData[j].LINE_NO !== 'N/A') {
        const partDetailDynamic: any[] = [];
        const fsiFormElement = this.fsiFormData[j];

        let countryKey: string;
        let countryDetail: string;
        let attribValue: string;

        if (fsiFormElement.COUNTRY_KEY == null) {
          countryKey = '0';
          countryDetail = 'Consolidated';
          attribValue = fsiFormElement.ATTRIB_VALUE;
        } else {
          if (fsiFormElement.COUNTRY_KEY.includes('~~')) {
            countryKey = fsiFormElement.COUNTRY_KEY.split('~~')[0];
            countryDetail = fsiFormElement.COUNTRY_DETAILS ? fsiFormElement.COUNTRY_DETAILS.split('~~')[0] : '';
            attribValue = fsiFormElement.ATTRIB_VALUE ? fsiFormElement.ATTRIB_VALUE.split('~~')[0] : '';
          } else {
            countryKey = fsiFormElement.COUNTRY_KEY;
            countryDetail = fsiFormElement.COUNTRY_DETAILS;
            attribValue = fsiFormElement.ATTRIB_VALUE;
          }
        }

        partDetailDynamic.push({ COUNTRY_KEY: countryKey, COUNTRY_DETAILS: countryDetail, ATTRIB_VALUE: attribValue });

        for (let k = 1; k < this.countryDetails.length; k++) {
          const ck = this.countryKeys[k];
          const cd = this.countryDetails[k];
          let av: string;

          if (fsiFormElement.ATTRIB_VALUE != null && fsiFormElement.ATTRIB_VALUE.includes('~~')) {
            av = fsiFormElement.ATTRIB_VALUE.split('~~')[k];
          } else {
            av = fsiFormElement.COL_ID === 'CONS' ? '0' : attribValue;
          }

          partDetailDynamic.push({ COUNTRY_KEY: ck, COUNTRY_DETAILS: cd, ATTRIB_VALUE: av });
        }

        this.fsiFormData[j].DYNAMIC_COUNTRY = partDetailDynamic;
      }
    }

    // Build chart_key list
    this.chart_key = [];
    for (let k = 0; k < this.fsiFormData.length; k++) {
      if (this.fsiFormData[k].CHART_KEY != null && !this.chart_key.includes(this.fsiFormData[k].CHART_KEY)) {
        this.chart_key.push(this.fsiFormData[k].CHART_KEY);
      }
    }

    this.myCountryList = [];
    if (this.countryKeys.length > 1) {
      this.countryPresent = true;
      for (let c = 1; c < this.countryKeys.length; c++) {
        const myCountry: any = {
          COUNTRY_KEY: this.countryKeys[c],
          COUNTRY_DESCRIPTION: this.countryDetails[c]
        };
        if (c === 1) {
          this.mySelectedCountry = { ...myCountry };
        }
        this.myCountryList.push(myCountry);
      }
      const CountryString = this.countryKeys.join(',');
      this.countryKeyList = CountryString.substring(2, CountryString.length);
      this.loadGIAccountsWithBaskets(this.countryKeys[1]);
    } else {
      this.countryPresent = false;
    }
  }

  // ─── FSI-GI TAB DATA LOADING ──────────────────────────────────────────

  private loadGIAccountsWithBaskets(countryKey: string) {
    this.service.loadGIAccountsWithBaskets(
      this.GENERAL_CONFIG.base_url, this.TAX_YEAR, this.scenario, this.rowData, this.jcd_key, this.countryKeyList, this.logged_in_user
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.processGIBasketData(response.jsonObject || [], countryKey);
        this.cdr.detectChanges();
      },
      (error: any) => {
        console.error('Error loading GI basket data:', error);
        this.cdr.detectChanges();
      }
    );
  }

  private processGIBasketData(data: any[], countryKey: string) {
    this.fsiGIBasketData = data;
    this.fsiGIBasketDataByCountry = [];
    this.allBasketData = [];
    this.basketData = [];

    for (let c = 1; c < this.countryKeys.length; c++) {
      const ctKey = this.countryKeys[c];
      // Use loose == matching to handle COUNTRY_KEY being number vs string from API
      this.fsiGIBasketDataByCountry[c - 1] = this.fsiGIBasketData.filter((r: any) => r.COUNTRY_KEY == ctKey);
    }

    for (let i = 0; i < this.fsiGIBasketDataByCountry.length; i++) {
      const aCountryFSIGIBasketData = this.fsiGIBasketDataByCountry[i];
      let accCount = 0;
      this.basketData = [];

      for (let j = 0; j < aCountryFSIGIBasketData.length; j++) {
        const rowData = aCountryFSIGIBasketData[j];
        rowData['GENLIM'] = 0; rowData['GENLIM_CHANGED'] = 'N';
        rowData['BRANCH'] = 0; rowData['BRANCH_CHANGED'] = 'N';
        rowData['PASSIVE'] = 0; rowData['PASSIVE_CHANGED'] = 'N';
        rowData['TREATY'] = 0; rowData['TREATY_CHANGED'] = 'N';
        rowData['SEC901J'] = 0; rowData['SEC901J_CHANGED'] = 'N';

        if (rowData['BASKET_CODE'] === 'GENLIM') rowData['GENLIM'] = rowData['BASKET_AMT'];
        if (rowData['BASKET_CODE'] === 'BRANCH') rowData['BRANCH'] = rowData['BASKET_AMT'];
        if (rowData['BASKET_CODE'] === 'PASSIVE') rowData['PASSIVE'] = rowData['BASKET_AMT'];
        if (rowData['BASKET_CODE'] === 'TREATY') rowData['TREATY'] = rowData['BASKET_AMT'];
        if (rowData['BASKET_CODE'] === 'SEC901J') rowData['SEC901J'] = rowData['BASKET_AMT'];

        if (j === 0) {
          this.basketData.push(rowData);
        } else {
          // Use loose == matching to handle ACCT_KEY being number vs string from API
          if (aCountryFSIGIBasketData[j]['ACCT_KEY'] == aCountryFSIGIBasketData[j - 1]['ACCT_KEY']) {
            if (rowData['BASKET_CODE'] === 'GENLIM') this.basketData[accCount]['GENLIM'] = rowData['GENLIM'];
            if (rowData['BASKET_CODE'] === 'BRANCH') this.basketData[accCount]['BRANCH'] = rowData['BRANCH'];
            if (rowData['BASKET_CODE'] === 'PASSIVE') this.basketData[accCount]['PASSIVE'] = rowData['PASSIVE'];
            if (rowData['BASKET_CODE'] === 'TREATY') this.basketData[accCount]['TREATY'] = rowData['TREATY'];
            if (rowData['BASKET_CODE'] === 'SEC901J') this.basketData[accCount]['SEC901J'] = rowData['SEC901J'];
          } else {
            this.basketData.push(rowData);
            accCount = accCount + 1;
          }
        }
      }

      this.allBasketData.push([...this.basketData]);
      this.basketData = [];
    }

    this.showSelectedCountryFSIBasket(countryKey);
  }

  private basketData: any[] = [];

  showSelectedCountry(countryDescription: string) {
    // Update mySelectedCountry to reflect the user's selection
    const myCountry = _.find(this.myCountryList, { COUNTRY_DESCRIPTION: countryDescription });
    if (myCountry) {
      this.mySelectedCountry = { ...myCountry };
      this.showSelectedCountryFSIBasket(myCountry.COUNTRY_KEY);
    } else {
      // Fallback: look up by CODE_DESCRIPTION in the full country list
      const found = _.find(this.countryList, { CODE_DESCRIPTION: countryDescription });
      if (found) {
        this.showSelectedCountryFSIBasket(found.CODE_KEY);
      }
    }
  }

  showSelectedCountryFSIBasket(countryKey: string) {
    this.general_amt_total = 0; this.branch_amt_total = 0; this.passive_amt_total = 0;
    this.treaty_amt_total = 0; this.sec901j_amt_total = 0;
    this.general_amt_var = 0; this.branch_amt_var = 0; this.passive_amt_var = 0;
    this.treaty_amt_var = 0; this.sec901j_amt_var = 0;

    const general = _.filter(this.fsiFormData, { LINE_NO: '16G' });
    const branch = _.filter(this.fsiFormData, { LINE_NO: '16E' });
    const passive = _.filter(this.fsiFormData, { LINE_NO: '16F' });
    const treaty = _.filter(this.fsiFormData, { LINE_NO: '16H1' });
    const sec901j = _.filter(this.fsiFormData, { LINE_NO: '16H2' });

    if (general.length > 0 && general[0].DYNAMIC_COUNTRY) {
      const found = general[0].DYNAMIC_COUNTRY.find((r: any) => r.COUNTRY_KEY == countryKey);
      this.general_amt_fsi = found ? found.ATTRIB_VALUE : 0;
    }
    if (branch.length > 0 && branch[0].DYNAMIC_COUNTRY) {
      const found = branch[0].DYNAMIC_COUNTRY.find((r: any) => r.COUNTRY_KEY == countryKey);
      this.branch_amt_fsi = found ? found.ATTRIB_VALUE : 0;
    }
    if (passive.length > 1 && passive[1].DYNAMIC_COUNTRY) {
      const found = passive[1].DYNAMIC_COUNTRY.find((r: any) => r.COUNTRY_KEY == countryKey);
      this.passive_amt_fsi = found ? found.ATTRIB_VALUE : 0;
    }
    if (treaty.length > 0 && treaty[0].DYNAMIC_COUNTRY) {
      const found = treaty[0].DYNAMIC_COUNTRY.find((r: any) => r.COUNTRY_KEY == countryKey);
      this.treaty_amt_fsi = found ? found.ATTRIB_VALUE : 0;
    }
    if (sec901j.length > 0 && sec901j[0].DYNAMIC_COUNTRY) {
      const found = sec901j[0].DYNAMIC_COUNTRY.find((r: any) => r.COUNTRY_KEY == countryKey);
      this.sec901j_amt_fsi = found ? found.ATTRIB_VALUE : 0;
    }

    for (let x = 0; x < this.allBasketData.length; x++) {
      // Use loose == matching to handle COUNTRY_KEY being number vs string from API
      this.selectedBasketData = (this.allBasketData[x] as any[]).filter((r: any) => r.COUNTRY_KEY == countryKey);
      if (this.selectedBasketData.length > 0) break;
    }

    for (let i = 0; i < this.selectedBasketData.length; i++) {
      this.general_amt_total += Number(this.selectedBasketData[i]['GENLIM']);
      this.branch_amt_total += Number(this.selectedBasketData[i]['BRANCH']);
      this.passive_amt_total += Number(this.selectedBasketData[i]['PASSIVE']);
      this.treaty_amt_total += Number(this.selectedBasketData[i]['TREATY']);
      this.sec901j_amt_total += Number(this.selectedBasketData[i]['SEC901J']);
    }

    this.general_amt_var = Number(this.general_amt_fsi) - this.general_amt_total;
    this.branch_amt_var = Number(this.branch_amt_fsi) - this.branch_amt_total;
    this.passive_amt_var = Number(this.passive_amt_fsi) - this.passive_amt_total;
    this.treaty_amt_var = Number(this.treaty_amt_fsi) - this.treaty_amt_total;
    this.sec901j_amt_var = Number(this.sec901j_amt_fsi) - this.sec901j_amt_total;

    this.cdr.detectChanges();
  }

  // ─── BEAT/GILTI/FDII TAB DATA LOADING ────────────────────────────────

  private loadBeatGiltiFdiiData() {
    this.service.loadBeatGiltiFdii(
      this.GENERAL_CONFIG.base_url, this.TAX_YEAR, this.scenario, this.rowData, this.jcd_key, this.countryKeyList, this.logged_in_user
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.beatGiltiFdiiData = response.jsonObject || [];
        this.beatData = _.filter(this.beatGiltiFdiiData, { SECTION_NAME: 'BEAT' });
        this.giltiData = _.filter(this.beatGiltiFdiiData, { SECTION_NAME: 'GILTI' });
        this.fdiiData = _.filter(this.beatGiltiFdiiData, { SECTION_NAME: 'FDII' });
        this.s864c8Data = _.filter(this.beatGiltiFdiiData, { SECTION_NAME: 'S864C8' });
        this.cdr.detectChanges();
      },
      (error: any) => {
        console.error('Error loading BEAT/GILTI/FDII data:', error);
        this.cdr.detectChanges();
      }
    );
  }

  // ─── K1 TAB LOGIC ────────────────────────────────────────────────────

  displayDropDownList(formLineKey: string, codeGroup: string): any[] {
    const listOfSelectedGroup = _.filter(this.allDropdownList, { CODE_GROUP: codeGroup });
    return listOfSelectedGroup.map((item: any) => ({
      name: item.CODE_DESC,
      value: item.CODE_KEY
    }));
  }

  compareDropdownObj(a: any, b: any): boolean {
    if (a === b) return true;
    if (a == null || b == null) return false;
    const aVal = (typeof a === 'object') ? a.value : a;
    const bVal = (typeof b === 'object') ? b.value : b;
    return aVal == bVal;
  }

  showHideSection(id: string) {
    if (id === 'k1caplib') this.showK1Caplib = !this.showK1Caplib;
    if (id === 'ti') this.showTI = !this.showTI;
    if (id === 'credits') this.showCredits = !this.showCredits;
    if (id === 'amtace') this.showAMTACE = !this.showAMTACE;
    if (id === 'other') this.showOTHER = !this.showOTHER;
    if (id === 'taxcapital') this.showTAXCAPITAL = !this.showTAXCAPITAL;
    if (id === 'fsi') this.showFSI = !this.showFSI;
    this.cdr.detectChanges();
  }

  setChange(row: any) {
    row.IS_CHANGED_FLAG = 'Y';
  }

  applyFormulaMain(row: any) {
    row.IS_CHANGED_FLAG = 'Y';
    if (row.DATA_TYPE === 'number') {
      const sectionName = row.SECTION_NAME;
      if (['K1CAPLIB', 'TI', 'CREDIT', 'AMTACE', 'OTHER', 'TAXCAPITAL'].includes(sectionName)) {
        const formFormulaList = this.filterFormulasBySubstring(this.allFormFormulaList, sectionName, sectionName);
        const formList = _.filter(this.allFormData, { SECTION_NAME: sectionName });
        for (const formula of formFormulaList) {
          if (formula.ATTRIB_CALC_FORMULA?.trim().length > 0) {
            this.calcAmt(formula.ATTRIB_CALC_FORMULA, formula.LINE_NO, formula.LINE_ATTRIB_KEY, row.DATA_TYPE, formList);
          }
        }
      }

      const formListTaxCap = _.filter(this.allFormData, { SECTION_NAME: 'TAXCAPITAL' });
      const formulaListTaxCap = _.filter(this.allFormFormulaList, { SECTION_NAME: 'TAXCAPITAL' });

      const dependentFormulas = [
        ..._.filter(formulaListTaxCap, (f: any) => f.ATTRIB_CALC_FORMULA && String(f.ATTRIB_CALC_FORMULA).indexOf('K1CAPLIB') !== -1),
        ..._.filter(formulaListTaxCap, (f: any) => f.ATTRIB_CALC_FORMULA && String(f.ATTRIB_CALC_FORMULA).indexOf('TI') !== -1),
        ..._.filter(formulaListTaxCap, (f: any) => f.ATTRIB_CALC_FORMULA && String(f.ATTRIB_CALC_FORMULA).indexOf('OTHER') !== -1)
      ];

      for (const formula of dependentFormulas) {
        if (formula.ATTRIB_CALC_FORMULA?.trim().length > 0) {
          this.calcTaxCapitalAmt(formula.ATTRIB_CALC_FORMULA, formula.LINE_NO, formula.LINE_ATTRIB_KEY, row.DATA_TYPE, formListTaxCap);
        }
      }

      const taxCapFormulas = this.filterFormulasBySubstring(this.allFormFormulaList, 'TAXCAPITAL', 'TAXCAPITAL');
      const taxCapFormList = _.filter(this.allFormData, { SECTION_NAME: 'TAXCAPITAL' });
      for (const formula of taxCapFormulas) {
        if (formula.ATTRIB_CALC_FORMULA?.trim().length > 0) {
          this.calcAmt(formula.ATTRIB_CALC_FORMULA, formula.LINE_NO, formula.LINE_ATTRIB_KEY, row.DATA_TYPE, taxCapFormList);
        }
      }

      // Mirror AngularJS: if TI row with relevant FLC_CODE and countries present, refresh FSI basket totals
      if (this.countryPresent && row.SECTION_NAME === 'TI' && row.FLC_CODE != null) {
        const relevantFLCCodes = ['CGNI', 'DIV', 'RENTINC', 'ROYALTY', 'INTINC', 'NETGNLS', 'OTHINC'];
        if (relevantFLCCodes.includes(row.FLC_CODE)) {
          const selCountry = _.find(this.countryList, { CODE_DESCRIPTION: this.mySelectedCountry.COUNTRY_DESCRIPTION });
          if (selCountry) {
            this.showSelectedCountryFSIBasket(selCountry.CODE_KEY);
          }
        }
      }
    }
    this.cdr.detectChanges();
  }

  applyFormulaFSI(row: any, col: number) {
    row.IS_CHANGED_FLAG = 'Y';

    const formListTaxCap = _.filter(this.allFormData, { SECTION_NAME: 'TAXCAPITAL' });
    const taxCapFSIFormulas = _.filter(this.allFormFormulaList, { SECTION_NAME: 'TAXCAPITAL' });
    const fsiFormulas = _.filter(taxCapFSIFormulas, (f: any) =>
      f.ATTRIB_CALC_FORMULA && String(f.ATTRIB_CALC_FORMULA).indexOf('FSI') !== -1
    );

    for (const formula of fsiFormulas) {
      if (formula.ATTRIB_CALC_FORMULA?.trim().length > 0) {
        this.calcTaxCapitalAmtFSI(formula.ATTRIB_CALC_FORMULA, formula.LINE_NO, formula.LINE_ATTRIB_KEY, row.DATA_TYPE, formListTaxCap);
      }
    }

    const taxCapFormulas = this.filterFormulasBySubstring(this.allFormFormulaList, 'TAXCAPITAL', 'TAXCAPITAL');
    const taxCapFormList = _.filter(this.allFormData, { SECTION_NAME: 'TAXCAPITAL' });
    for (const formula of taxCapFormulas) {
      if (formula.ATTRIB_CALC_FORMULA?.trim().length > 0) {
        this.calcAmt(formula.ATTRIB_CALC_FORMULA, formula.LINE_NO, formula.LINE_ATTRIB_KEY, row.DATA_TYPE, taxCapFormList);
      }
    }

    // Mirror AngularJS: if FSI basket lines changed and countries present, refresh FSI basket totals
    if (this.countryPresent && row.DYNAMIC_COUNTRY) {
      const basketLines = ['16G', '16E', '16F', '16H1', '16H2'];
      if (basketLines.includes(row.LINE_NO)) {
        const countryKey = row.DYNAMIC_COUNTRY[col] ? row.DYNAMIC_COUNTRY[col]['COUNTRY_KEY'] : null;
        const selCountry = _.find(this.countryList, { CODE_DESCRIPTION: this.mySelectedCountry.COUNTRY_DESCRIPTION });
        const selCountryKey = selCountry ? selCountry.CODE_KEY : null;
        if (countryKey && selCountryKey && countryKey === selCountryKey) {
          this.showSelectedCountryFSIBasket(countryKey);
        }
      }
    }

    this.cdr.detectChanges();
  }

  // ─── FSI-GI RECALC METHODS ─────────────────────────────────────────────

  recalcGeneral(row: any) {
    row.IS_CHANGED_FLAG = 'Y'; row.GENLIM_CHANGED = 'Y';
    this.general_amt_total = 0; this.general_amt_var = 0;
    for (const item of this.selectedBasketData) { this.general_amt_total += Number(item['GENLIM']); }
    this.general_amt_var = Number(this.general_amt_fsi) - this.general_amt_total;
    this.cdr.detectChanges();
  }

  recalcBranch(row: any) {
    row.IS_CHANGED_FLAG = 'Y'; row.BRANCH_CHANGED = 'Y';
    this.branch_amt_total = 0; this.branch_amt_var = 0;
    for (const item of this.selectedBasketData) { this.branch_amt_total += Number(item['BRANCH']); }
    this.branch_amt_var = Number(this.branch_amt_fsi) - this.branch_amt_total;
    this.cdr.detectChanges();
  }

  recalcPassive(row: any) {
    row.IS_CHANGED_FLAG = 'Y'; row.PASSIVE_CHANGED = 'Y';
    this.passive_amt_total = 0; this.passive_amt_var = 0;
    for (const item of this.selectedBasketData) { this.passive_amt_total += Number(item['PASSIVE']); }
    this.passive_amt_var = Number(this.passive_amt_fsi) - this.passive_amt_total;
    this.cdr.detectChanges();
  }

  recalcTreaty(row: any) {
    row.IS_CHANGED_FLAG = 'Y'; row.TREATY_CHANGED = 'Y';
    this.treaty_amt_total = 0; this.treaty_amt_var = 0;
    for (const item of this.selectedBasketData) { this.treaty_amt_total += Number(item['TREATY']); }
    this.treaty_amt_var = Number(this.treaty_amt_fsi) - this.treaty_amt_total;
    this.cdr.detectChanges();
  }

  recalcSec901j(row: any) {
    row.IS_CHANGED_FLAG = 'Y'; row.SEC901J_CHANGED = 'Y';
    this.sec901j_amt_total = 0; this.sec901j_amt_var = 0;
    for (const item of this.selectedBasketData) { this.sec901j_amt_total += Number(item['SEC901J']); }
    this.sec901j_amt_var = Number(this.sec901j_amt_fsi) - this.sec901j_amt_total;
    this.cdr.detectChanges();
  }

  getTISumByFLCCodeGrouping(flcCode: string): number {
    const lines = _.filter(this.allFormData, { SECTION_NAME: 'TI', FLC_CODE: flcCode });
    let amount = 0;
    for (const line of lines) { amount += Number(line['ATTRIB_VALUE']); }
    return amount;
  }

  getBasketSumByFLCCodeGrouping(flcCode: string): number {
    let basketAmount = 0;
    for (const countryBasket of this.allBasketData) {
      const found = _.find(countryBasket, { FLC_CODE: flcCode });
      if (found) {
        basketAmount += Number(found['GENLIM']) + Number(found['BRANCH']) + Number(found['PASSIVE']) + Number(found['TREATY']) + Number(found['SEC901J']);
      }
    }
    return basketAmount;
  }

  // ─── FSI COUNTRY MANAGEMENT ────────────────────────────────────────────

  addCountryColumn(selectedCountryKey: string, selectedCountryValue: string) {
    if (!selectedCountryValue || !selectedCountryKey || selectedCountryKey === '0') return;

    let countryAlreadyAdded = false;
    for (const header of this.partHeaderDynamic) {
      if (header.ATTRIB_VALUE === selectedCountryValue) { countryAlreadyAdded = true; break; }
    }

    if (!countryAlreadyAdded) {
      this.colspan = this.colspan + 1;
      const clonedHeaderColumn = { ...this.partHeaderElement };
      clonedHeaderColumn.ATTRIB_NAME = this.partHeaderIIIFSIFormData[0].ATTRIB_NAME + '_' + this.partHeaderDynamic.length;
      clonedHeaderColumn.ATTRIB_VALUE = selectedCountryValue;
      clonedHeaderColumn.ATTRIB_DESCRIPTION = selectedCountryValue;
      this.partHeaderDynamic.push(clonedHeaderColumn);

      for (let j = 0; j < this.fsiFormData.length; j++) {
        if (this.fsiFormData[j].ROW_TYPE !== 'SH') {
          const dynamicCountryElementArray = this.fsiFormData[j].DYNAMIC_COUNTRY;
          const lastElement = dynamicCountryElementArray[dynamicCountryElementArray.length - 1];
          const clonedElement = { ...lastElement };
          clonedElement['COUNTRY_KEY'] = selectedCountryKey;
          clonedElement['COUNTRY_DETAILS'] = selectedCountryValue;
          clonedElement['ATTRIB_VALUE'] = this.fsiFormData[j].DATA_TYPE === 'number' ? '0' : null;
          clonedElement['IS_CHANGED_FLAG'] = 'Y';
          dynamicCountryElementArray.push(clonedElement);
        }
      }

      this.countryKeys.push(selectedCountryKey);
      this.countryDetails.push(selectedCountryValue);
      this.updateCountryState();
      // Set the newly added country as the selected country for the FTC-GI tab dropdown,
      // matching AngularJS which always pre-selects the newly added country (not the first)
      this.mySelectedCountry = { COUNTRY_KEY: selectedCountryKey, COUNTRY_DESCRIPTION: selectedCountryValue };
    }
    this.cdr.detectChanges();
  }

  removeCountryColumn(index: number) {
    const found = _.find(this.countryList, { CODE_DESCRIPTION: this.partHeaderDynamic[index].ATTRIB_VALUE });
    if (found) { this.countriesToRemove.push(found.CODE_KEY); }

    this.partHeaderDynamic.splice(index, 1);
    const tdIndex = index + 1;

    for (let j = 0; j < this.fsiFormData.length; j++) {
      if (this.fsiFormData[j].ROW_TYPE !== 'SH') {
        this.fsiFormData[j].DYNAMIC_COUNTRY.splice(tdIndex, 1);
      }
    }

    this.colspan = this.colspan - 1;
    this.countryKeys.splice(index, 1);
    this.countryDetails.splice(index, 1);
    this.updateCountryState();
    this.cdr.detectChanges();
  }

  private updateCountryState() {
    this.countryPresent = this.countryKeys.length > 1;
    this.myCountryList = [];
    if (this.countryKeys.length > 1) {
      for (let c = 1; c < this.countryKeys.length; c++) {
        const myCountry: any = { COUNTRY_KEY: this.countryKeys[c], COUNTRY_DESCRIPTION: this.countryDetails[c] };
        if (c === 1) { this.mySelectedCountry = { ...myCountry }; }
        this.myCountryList.push(myCountry);
      }
      const CountryString = this.countryKeys.join(',');
      this.countryKeyList = CountryString.substring(2, CountryString.length);
      this.loadGIAccountsWithBaskets(this.countryKeys[1]);
    }
  }

  // ─── FORMULA CALCULATION ───────────────────────────────────────────────

  private filterFormulasBySubstring(formulaList: any[], sectionName: string, formulaSubstring: string): any[] {
    return _.filter(formulaList, (f: any) =>
      f.SECTION_NAME === sectionName &&
      f.ATTRIB_CALC_FORMULA &&
      String(f.ATTRIB_CALC_FORMULA).indexOf(formulaSubstring) !== -1
    );
  }

  private calcAmt(formula: string, lineNo: string, attribKey: string, dataType: string, targetFormList: any[]) {
    try {
      const matches = formula.match(/\b[^\d\s]+\b/g);
      let lineFormulaArray: string[] = [];
      if (matches == null) { lineFormulaArray = formula.split(/[+-/\\*\\]/); }

      for (let i = 0; i < lineFormulaArray.length; i++) {
        lineFormulaArray[i] = lineFormulaArray[i].replace(/"/g, '').replace(/'/g, '').replace(/\(|\)/g, '');
        const formulaOperandText = lineFormulaArray[i].trim();
        const sourceItem = _.find(targetFormList, { ATTRIB_NAME: formulaOperandText, DATA_TYPE: 'number' });
        if (!sourceItem) continue;
        const lineAmt = parseFloat(sourceItem.ATTRIB_VALUE) || 0;
        formula = lineAmt >= 0
          ? formula.replace('(' + lineFormulaArray[i].trim() + ')', String(lineAmt))
          : formula.replace('(' + lineFormulaArray[i].trim() + ')', '(' + lineAmt + ')');
      }

      const evalResult = safeEvalFormula(formula, null, 'partner-alloc.calcAmt');
      if (evalResult != null && parseInt(String(evalResult)) === parseInt(String(evalResult))) {
        const targetItem = _.filter(targetFormList, { LINE_NO: lineNo, LINE_ATTRIB_KEY: attribKey });
        if (targetItem.length > 0) {
          const originalValue = targetItem[0].ATTRIB_VALUE;
          targetItem[0].ATTRIB_VALUE = evalResult.toFixed();
          if (dataType != null && originalValue !== targetItem[0].ATTRIB_VALUE) {
            targetItem[0].IS_CHANGED_FLAG = 'Y';
          }
        }
      }
    } catch (e) { console.error('Error in calcAmt:', e); }
  }

  private calcTaxCapitalAmt(formula: string, lineNo: string, attribKey: string, dataType: string, targetFormList: any[]) {
    try {
      const matches = formula.match(/\b[^\d\s]+\b/g);
      let lineFormulaArray: string[] = [];
      if (matches == null) { lineFormulaArray = formula.split(/[+-/\\*\\]/); }

      for (let i = 0; i < lineFormulaArray.length; i++) {
        lineFormulaArray[i] = lineFormulaArray[i].replace(/"/g, '').replace(/'/g, '').replace(/\(|\)/g, '');
        let formulaOperandText = lineFormulaArray[i].trim();
        let hasGT = false; let hasLT = false;

        if (formulaOperandText.includes('>')) { hasGT = true; formulaOperandText = formulaOperandText.replace('>', ''); }
        else if (formulaOperandText.includes('<')) { hasLT = true; formulaOperandText = formulaOperandText.replace('<', ''); }

        const sourceItem = _.find(this.allFormData, { ATTRIB_NAME: formulaOperandText, DATA_TYPE: 'number' });
        if (!sourceItem) continue;
        const lineAmt = parseFloat(sourceItem.ATTRIB_VALUE) || 0;

        if (!hasGT && !hasLT) {
          formula = lineAmt >= 0
            ? formula.replace('(' + formulaOperandText + ')', String(lineAmt))
            : formula.replace('(' + formulaOperandText + ')', '(' + lineAmt + ')');
        } else if (hasGT) {
          formula = lineAmt > 0
            ? formula.replace('(' + formulaOperandText + '(>))', String(lineAmt))
            : formula.replace('(' + formulaOperandText + '(>))', '0');
        } else if (hasLT) {
          formula = lineAmt < 0
            ? formula.replace('(' + formulaOperandText + '(<))', '(' + lineAmt + ')')
            : formula.replace('(' + formulaOperandText + '(<))', '0');
        }
      }

      const evalResult = safeEvalFormula(formula, null, 'partner-alloc.calcTaxCapitalAmt');
      if (evalResult != null && parseInt(String(evalResult)) === parseInt(String(evalResult))) {
        const targetItem = _.filter(targetFormList, { LINE_NO: lineNo, LINE_ATTRIB_KEY: attribKey });
        if (targetItem.length > 0) {
          const originalValue = targetItem[0].ATTRIB_VALUE;
          targetItem[0].ATTRIB_VALUE = evalResult.toFixed();
          if (dataType != null && originalValue !== targetItem[0].ATTRIB_VALUE) {
            targetItem[0].IS_CHANGED_FLAG = 'Y';
          }
        }
      }
    } catch (e) { console.error('Error in calcTaxCapitalAmt:', e); }
  }

  private calcTaxCapitalAmtFSI(formula: string, lineNo: string, attribKey: string, dataType: string, targetFormList: any[]) {
    try {
      const matches = formula.match(/\b[^\d\s]+\b/g);
      let lineFormulaArray: string[] = [];
      if (matches == null) { lineFormulaArray = formula.split(/[+-/\\*\\]/); }

      for (let i = 0; i < lineFormulaArray.length; i++) {
        lineFormulaArray[i] = lineFormulaArray[i].replace(/"/g, '').replace(/'/g, '').replace(/\(|\)/g, '');
        const formulaOperandText = lineFormulaArray[i].trim();
        const sourceItem = _.find(this.fsiFormData, { ATTRIB_NAME: formulaOperandText, DATA_TYPE: 'number' });
        if (!sourceItem) continue;

        let lineAmt = 0;
        if (sourceItem.DYNAMIC_COUNTRY) {
          for (let x = 1; x < sourceItem.DYNAMIC_COUNTRY.length; x++) {
            lineAmt += parseFloat(sourceItem.DYNAMIC_COUNTRY[x].ATTRIB_VALUE) || 0;
          }
        }

        formula = lineAmt >= 0
          ? formula.replace('(' + formulaOperandText + ')', String(lineAmt))
          : formula.replace('(' + formulaOperandText + ')', '(' + lineAmt + ')');
      }

      const evalResult = safeEvalFormula(formula, null, 'partner-alloc.calcTaxCapitalAmtFSI');
      if (evalResult != null && parseInt(String(evalResult)) === parseInt(String(evalResult))) {
        const targetItem = _.filter(targetFormList, { LINE_NO: lineNo, LINE_ATTRIB_KEY: attribKey });
        if (targetItem.length > 0) {
          const originalValue = targetItem[0].ATTRIB_VALUE;
          targetItem[0].ATTRIB_VALUE = evalResult.toFixed();
          if (dataType != null && originalValue !== targetItem[0].ATTRIB_VALUE) {
            targetItem[0].IS_CHANGED_FLAG = 'Y';
          }
        }
      }
    } catch (e) { console.error('Error in calcTaxCapitalAmtFSI:', e); }
  }

  // ─── SAVE ─────────────────────────────────────────────────────────────

  saveAndPost() {
    if (this.crudLoading) {
      this.gtwSnackbar.openSnackBar('Please wait while we save this request', 'gtw-snackbar--yellow', true, 4);
      return;
    }

    if (this.issueList.length > 0 && this.issueList[0].SCENARIO_TYPE_CODE === 'EXAM') {
      if (this.selectedIssue === '') {
        this.gtwSnackbar.openSnackBar('Please select an issue from the list', 'gtw-snackbar--red', true, 4);
        this.isSaveClicked = false;
        return;
      }
    }

    this.handleSave('Partner Allocation Details successfully saved and posted');
  }

  private handleSave(successMessage: string) {
    if (this.crudLoading) return;

    this.isSaveClicked = true;
    this.crudLoading = true;
    this.cdr.detectChanges();

    // Mirror AngularJS: issueID is already split from selectedIssue when EXAM scenario
    let issueID: any = 0;
    if (this.issueList.length > 0 && this.issueList[0].SCENARIO_TYPE_CODE === 'EXAM' && this.selectedIssue !== '') {
      issueID = this.selectedIssue.split('--')[0];
    }

    const EXTK1FormSaveDtls: any[] = [];
    const tabNames = ['main', 'fsi'];

    if (this.countryKeys.length > 1) tabNames.push('fsi_gi');
    if (Number(this.TAX_YEAR) >= 2020) tabNames.push('beat_gilti_fdii');

    const allSaveData: any[][] = [];

    // Mirror AngularJS: exact match {IS_CHANGED_FLAG:'Y', ATTRIB_COL:'a'}
    allSaveData.push(_.filter(this.allFormData, { IS_CHANGED_FLAG: 'Y', ATTRIB_COL: 'a' }));
    allSaveData.push(_.filter(this.fsiFormData, { IS_CHANGED_FLAG: 'Y', ATTRIB_COL: 'a' }));

    if (tabNames.includes('fsi_gi')) {
      // allBasketData is an array of arrays (one inner array per country).
      // AngularJS $filter("filter") does a deep search and returns outer arrays
      // that contain at least one inner row with IS_CHANGED_FLAG:'Y'.
      // Lodash _.filter cannot do this, so replicate the deep-filter manually.
      const changedBaskets = this.allBasketData.filter((countryArr: any[]) =>
        Array.isArray(countryArr) && countryArr.some((row: any) => row.IS_CHANGED_FLAG === 'Y')
      );
      allSaveData.push(changedBaskets);
    }
    if (tabNames.includes('beat_gilti_fdii')) {
      allSaveData.push(_.filter(this.beatGiltiFdiiData, { IS_CHANGED_FLAG: 'Y' }));
    }

    const fsiGiIndex = tabNames.indexOf('fsi_gi');
    const beatGiltiIndex = tabNames.indexOf('beat_gilti_fdii');

    for (let key = 0; key < allSaveData.length; key++) {
      const saveData = allSaveData[key];
      for (let i = 0; i < saveData.length; i++) {
        let returnObj: any = {};

        if (key === 0) { // main tab
          returnObj.section_name = 'main';
          returnObj.pship_ptr_posting_key = this.PSHIP_PTR_POSTING_KEY;
          returnObj.combination_key = this.COMBINATION_KEY;
          returnObj.ptr_combination_key = this.PTR_COMBINATION_KEY;
          returnObj.chart_key = saveData[i].CHART_REF_KEY;
          returnObj.acct_ref_key = saveData[i].ACCT_REFERENCE_KEY;
          returnObj.allocation_amount = (typeof saveData[i].ATTRIB_VALUE === 'object' && saveData[i].SUB_FORM != null)
            ? JSON.stringify(saveData[i].ATTRIB_VALUE)
            : saveData[i].ATTRIB_VALUE;
          returnObj.flow_through = 0;
          EXTK1FormSaveDtls.push(returnObj);
        }

        if (key === 1) { // fsi tab
          if (saveData[i].DYNAMIC_COUNTRY) {
            for (let x = 0; x < saveData[i].DYNAMIC_COUNTRY.length; x++) {
              returnObj = {};
              if (saveData[i].COL_ID === 'CONS') {
                if (x === 0) {
                  returnObj.section_name = 'main';
                  returnObj.pship_ptr_posting_key = this.PSHIP_PTR_POSTING_KEY;
                  returnObj.combination_key = this.COMBINATION_KEY;
                  returnObj.ptr_combination_key = this.PTR_COMBINATION_KEY;
                  returnObj.chart_key = saveData[i].CHART_REF_KEY;
                  returnObj.acct_ref_key = saveData[i].ACCT_REFERENCE_KEY;
                  returnObj.country_key = saveData[i].DYNAMIC_COUNTRY[x].COUNTRY_KEY;
                  returnObj.allocation_amount = saveData[i].DYNAMIC_COUNTRY[x].ATTRIB_VALUE;
                  returnObj.flow_through = 0;
                  EXTK1FormSaveDtls.push(returnObj);
                }
              } else {
                if (x === 0) {
                  returnObj.section_name = 'main';
                  returnObj.pship_ptr_posting_key = this.PSHIP_PTR_POSTING_KEY;
                  returnObj.combination_key = this.COMBINATION_KEY;
                  returnObj.ptr_combination_key = this.PTR_COMBINATION_KEY;
                  returnObj.chart_key = saveData[i].CHART_REF_KEY;
                  returnObj.acct_ref_key = saveData[i].ACCT_REFERENCE_KEY;
                  returnObj.country_key = saveData[i].DYNAMIC_COUNTRY[x].COUNTRY_KEY;
                  let amount = 0;
                  for (let y = 1; y < saveData[i].DYNAMIC_COUNTRY.length; y++) {
                    if (saveData[i].DYNAMIC_COUNTRY[y].ATTRIB_VALUE != null) {
                      amount += parseFloat(saveData[i].DYNAMIC_COUNTRY[y].ATTRIB_VALUE);
                    }
                  }
                  returnObj.allocation_amount = amount;
                  returnObj.flow_through = 0;
                  EXTK1FormSaveDtls.push(returnObj);
                }
                if (x > 0) {
                  returnObj.section_name = 'fsi';
                  returnObj.pship_ptr_posting_key = this.PSHIP_PTR_POSTING_KEY;
                  returnObj.combination_key = this.COMBINATION_KEY;
                  returnObj.ptr_combination_key = this.PTR_COMBINATION_KEY;
                  returnObj.chart_key = saveData[i].CHART_REF_KEY;
                  returnObj.acct_ref_key = saveData[i].ACCT_REFERENCE_KEY;
                  returnObj.country_key = saveData[i].DYNAMIC_COUNTRY[x].COUNTRY_KEY;
                  returnObj.allocation_amount = saveData[i].DYNAMIC_COUNTRY[x].ATTRIB_VALUE;
                  returnObj.flow_through = 0;
                  EXTK1FormSaveDtls.push(returnObj);
                }
              }
            }
          }
        }

        if (key === fsiGiIndex && fsiGiIndex > 0) { // fsi_gi tab
          if (allSaveData[key][0]) {
            for (let a = 0; a < 7; a++) {
              if (saveData[i] && saveData[i][a] && saveData[i][a].IS_CHANGED_FLAG === 'Y') {
                for (let b = 0; b < 5; b++) {
                  returnObj = {};
                  returnObj.section_name = 'fsi_gi';
                  returnObj.pship_ptr_posting_key = this.PSHIP_PTR_POSTING_KEY;
                  returnObj.combination_key = this.COMBINATION_KEY;
                  returnObj.ptr_combination_key = this.PTR_COMBINATION_KEY;
                  returnObj.country_key = saveData[i][a].COUNTRY_KEY;
                  returnObj.chart_key = saveData[i][a].CHART_KEY;
                  returnObj.acct_ref_key = saveData[i][a].ACCT_KEY;

                  if (b === 0 && saveData[i][a].GENLIM_CHANGED === 'Y') { returnObj.fsi_key = 91; returnObj.allocation_amount = saveData[i][a].GENLIM; EXTK1FormSaveDtls.push(returnObj); }
                  if (b === 1 && saveData[i][a].BRANCH_CHANGED === 'Y') { returnObj.fsi_key = 92; returnObj.allocation_amount = saveData[i][a].BRANCH; EXTK1FormSaveDtls.push(returnObj); }
                  if (b === 2 && saveData[i][a].PASSIVE_CHANGED === 'Y') { returnObj.fsi_key = 93; returnObj.allocation_amount = saveData[i][a].PASSIVE; EXTK1FormSaveDtls.push(returnObj); }
                  if (b === 3 && saveData[i][a].TREATY_CHANGED === 'Y') { returnObj.fsi_key = 89; returnObj.allocation_amount = saveData[i][a].TREATY; EXTK1FormSaveDtls.push(returnObj); }
                  if (b === 4 && saveData[i][a].SEC901J_CHANGED === 'Y') { returnObj.fsi_key = 86; returnObj.allocation_amount = saveData[i][a].SEC901J; EXTK1FormSaveDtls.push(returnObj); }
                }
              }
            }
          }
        }

        if (key === beatGiltiIndex && beatGiltiIndex > 0) { // beat/gilti/fdii tab
          returnObj = {};
          returnObj.section_name = 'beat_gilti_fdii';
          returnObj.pship_ptr_posting_key = this.PSHIP_PTR_POSTING_KEY;
          returnObj.combination_key = this.COMBINATION_KEY;
          returnObj.ptr_combination_key = this.PTR_COMBINATION_KEY;
          returnObj.chart_key = saveData[i].CHART_REF_KEY;
          returnObj.acct_ref_key = saveData[i].ACCT_REFERENCE_KEY;
          const val = saveData[i].ATTRIB_VALUE;
          if (saveData[i].ROW_TYPE === 'DTA') { returnObj.fgn_trans_dtls = val; }
          else { returnObj.allocation_amount = val; }
          returnObj.flow_through = 0;
          EXTK1FormSaveDtls.push(returnObj);
        }
      }
    }

    // Mirror AngularJS: always set all clobSettings fields regardless of countriesToRemove
    const returnClobSettingsObj: any = {
      tax_year: this.TAX_YEAR,
      scenario: this.scenario,
      sso_id: this.logged_in_user,
      issue_id: issueID,
      pship_ptr_posting_key: this.PSHIP_PTR_POSTING_KEY,
      combination_key: this.COMBINATION_KEY,
      ptr_combination_key: this.PTR_COMBINATION_KEY,
      chart_key: this.chart_key[0] || null,
      countries_to_remove: (this.countriesToRemove != null && this.countriesToRemove.length > 0)
        ? this.countriesToRemove.toString()
        : '0',
        jcd_key: this.jcd_key
    };

    const saveObservable = this.service.savePartnerAllocationForm(this.GENERAL_CONFIG.base_url, returnClobSettingsObj, EXTK1FormSaveDtls);

    saveObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.isSaveClicked = false;
        this.crudLoading = false;
        if (response.errorMessage && response.errorMessage !== 'null') {
          this.gtwSnackbar.openSnackBar(response.errorMessage, 'gtw-snackbar--red', true, 4);
        } else {
          this.gtwSnackbar.openSnackBar(successMessage, 'gtw-snackbar--green', true, 4);
          this.requestGridUpdate.emit('refresh');
        }
        this.cdr.detectChanges();
      },
      (error: any) => {
        this.isSaveClicked = false;
        this.crudLoading = false;
        this.gtwSnackbar.openSnackBar('Error occurred while saving. Please try again.', 'gtw-snackbar--red', true, 4);
        this.cdr.detectChanges();
      }
    );
  }

  cancel() {
    this.requestGridUpdate.emit('cancel');
  }

  // ─── UTILITY ──────────────────────────────────────────────────────────

  isJson(str: any): boolean {
    try { safeJsonInput<any>(str, null, 'partner-alloc.parse2'); } catch (e) { return false; }
    return true;
  }

  formatNumber(value: any): string {
    if (value == null || value === '') return '';
    const num = Number(value);
    if (isNaN(num)) return value;
    if (num < 0) { return '(' + Math.abs(num).toLocaleString('en-US') + ')'; }
    return num.toLocaleString('en-US');
  }


  trackByIndex(index: number): number {
    return index;
  }
}
